// extracted by mini-css-extract-plugin
export default {"root":"F2WFug","bg":"U9rlVT","ctr":"WWUoVh","top":"uAj5jQ","bot":"ga_tv6"};